module.exports = __webpack_public_path__ + "static/media/segment-icon3.dc84be67.svg";